import { React, useState, useEffect } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash, faEye, faQrcode } from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "@mui/material";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import Swal from "sweetalert2";
import ReactDOMServer from "react-dom/server";
import { Toaster, toast } from 'react-hot-toast';
import { QRCodeCanvas } from "qrcode.react";
import CryptoJS from "crypto-js";
import * as ReactDOM from "react-dom";
import { PropagateLoader } from "react-spinners";
import { TablePagination } from '@mui/material';

export default function FacilityReservation() {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(5);
    const [totalItems, setTotalItems] = useState(1);
    const [sortColumn, setSortColumn] = useState(null);
    const [sortOrder, setSortOrder] = useState('asc');
    // const [viewFlag, setViewFlag] = useState(false);
    const [loading, setLoading] = useState(false);
    // const [qrData, setQrData] = useState("");
    // const [showQR, setShowQR] = useState(false);
    // const [selectedQR, setSelectedQR] = useState(null);
    const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;
    useEffect(() => {
        getTableData();
    }, []);

    const filteredData = data.filter(item =>
        item.purpose.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const sortedData = [...filteredData].sort((a, b) => {
        if(sortColumn === null) return 0;
        const aValue = a[sortColumn] || '';
        const bValue = b[sortColumn] || '';
    
        if (typeof aValue === "string") {
            return sortOrder === "asc"
                ? aValue.localeCompare(bValue)
                : bValue.localeCompare(aValue);
        } else {
            return sortOrder === "asc"
                ? (aValue || 0) - (bValue || 0)
                : (bValue || 0) - (aValue || 0);
        }
    });

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem || []);
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    const handleSort = (column) => {
        setSortOrder((prevOrder) =>
            sortColumn === column && prevOrder === "asc" ? "desc" : "asc"
        );
        setSortColumn(column);
    };

    const cleanData = (data) => {
        return data.map(item => ({
            ...item,
            purpose: item.purpose || '', 
            studentsName: item.first_name || '',
            phone: item.phone,
            facility : item.facility_name || '',
            // mentors_name: item.mentors_name || '',
            status: item.status || '',
            description: item.description || ''
        }));
    };
    
  
    async function getTableData() {
        try {
            setLoading(true);
            const loginToken = localStorage.getItem('token');
            const getApiResponse = await axios.get("https://api.nvcti.in/facility/registration/getAllFacilityRegistrations", {
                headers: {
                    "Authorization": `Bearer ${loginToken}`,
                    "Content-Type": "application/json"
                }
            });
            const cleandata =cleanData(getApiResponse.data);
            console.log("hey",getApiResponse.data)
            setData(cleandata);
            setTotalItems(cleandata.length)
            toast.success("Data Fetch Successfully");
        } catch (error) {
            toast.error("Error fetching inventory", error);
            setData([]);
        } finally {
            setLoading(false);
        }
    }
    
    async function deleteFacility(id) {
        try {
            const loginToken = localStorage.getItem('token');
            const getApiResponse = await axios.delete("https://api.nvcti.in/facility/registration/deleteFacilityRegistration/" + id, {
            // const getApiResponse = await axios.delete("https://api.nvcti.in/facility/registration/deleteFacilityRegistration/" + id, {
                headers: {
                    "Authorization": `Bearer ${loginToken}`,
                    "Content-Type": "application/json"
                }
            })
            if (getApiResponse.status == 200) {
                getTableData();
            }
        } catch (error) {
            toast.error("Error fetching inventory:", error);
        }
    }

    const handleDelete = (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you really want to delete these records?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: ReactDOMServer.renderToString(
                <>
                    Yes, delete it!
                    <FontAwesomeIcon icon={faTrash} style={{ marginLeft: "10px" }} />
                </>
            ),
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            if (result.isConfirmed) {
                deleteFacility(id);
                Swal.fire({
                    title: "Deleted!",
                    text: "Facility record deleted successfully.",
                    icon: "success",
                    timer: 2000,
                    showConfirmButton: false,
                });
            }
        });
    };

    const encryptData = (registration_id) => {
        if (!registration_id) {
            toast.error("Error: registration_id is missing");
            return null;
        }
        const encrypted = CryptoJS.AES.encrypt(
            JSON.stringify(registration_id),
            SECRET_KEY
        ).toString();
        return encrypted;
    };

    const handleShowQR = (id, item) => {
        const encryptedData = encryptData(id);

        Swal.fire({
            title: "SCAN QR",
            html: `
                <p style="margin-bottom: 15px; font-size: 14px;">Scan this QR code to retrieve information securely.</p>
                <div id="qrcode-container" style="display: flex; justify-content: center; margin-bottom: 15px;"></div>
                
                <div style="display: flex; justify-content: center; gap: 10px;">
                    <button id="scan-button" class="swal2-confirm swal2-styled">Confirm Scan</button>
                    <button id="cancel-button" class="swal2-cancel swal2-styled custom-cancel-btn">Cancel</button>
                </div>
            `,
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            showCancelButton: false,
            didOpen: () => {
                const qrContainer = document.getElementById("qrcode-container");
                if (qrContainer) {
                    ReactDOM.createRoot(qrContainer).render(
                        <QRCodeCanvas value={encryptedData} size={150} />
                    );
                }

                document.getElementById("cancel-button").style.backgroundColor = "red";

                document.getElementById("scan-button").addEventListener("click", () => {
                    handleScan(encryptedData, item);
                });

                document.getElementById("cancel-button").addEventListener("click", () => {
                    Swal.close();
                });
            }
        });
    };

    const decryptData = (encryptedData) => {
        try {
            if (!encryptedData) {
                throw new Error("Error: Scanned data is empty");
            }

            const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
            const decryptedString = bytes.toString(CryptoJS.enc.Utf8);

            if (!decryptedString) {
                throw new Error("Decryption failed or returned empty string");
            }

            return decryptedString;
        } catch (error) {
            toast.error("Decryption error:", error.message);
            return null;
        }
    };

    const handleScan = async (scannedData, item) => {
        if (!scannedData) return;

        try {
            const decryptedId = decryptData(scannedData);

            if (Number(decryptedId) !== Number(item.facility_registration_id)) {
                Swal.fire("Error", "QR Code does not match any records!", "error");
                return;
            }

            if (item.status !== "issued") {
                Swal.fire("Warning", "This item is not in 'issued' state!", "warning");
                return;
            }

            const requestData = {
                registrationId: Number(decryptedId),
                status: "received",
            };

            const response = await fetch("api", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestData),
            });

            let data;
            try {
                data = await response.json();
            } catch (jsonError) {
                const errorText = await response.text();
                throw new Error(`Invalid JSON response: ${errorText}`);
            }

            if (response.ok) {
                Swal.fire("Success", "Status updated to 'received'!", "success").then(() => {
                    window.location.reload();
                });
            } else {
                Swal.fire("Error", data.message || "Failed to update status", "error");
            }
        } catch (error) {
            toast.error("QR Scan Error:", error);
            Swal.fire("Error", "Something went wrong while processing the QR code.", "error");
        }
    }

  const userId = localStorage.getItem("user_id");

    return (
        <>
            <Toaster position="bottom-left" reverseOrder={false} />
            <div className="relative">
                <div className="flex justify-between items-center px-4 mt-6">
                    <p className="font-semibold text-lg text-white">Facility Reservation Details</p>
                    <div className="flex">
                        <Tooltip title="Create Facility Reservation" arrow>
                            <button
                                className="bg-lightBlue-500 mb-0 text-white active:bg-lightBlue-600 font-semibold text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                                type="button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    navigate(`/admin/createFacilityReservation`,{ state: { type:"create",id:userId, fid:"" } });
                                    
                                }}>
                                Create Facility Reservation
                            </button>
                        </Tooltip>
                        <Tooltip title="Scan QR" arrow>
                            <button
                                className="relative text-white bg-blueGray-700 active:bg-blueGray-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150 ml-6"
                                type="button"
                                onClick={() => window.location.href = "/admin/scan-qr"}>
                                Scan QR
                            </button>
                        </Tooltip>
                    </div>
                </div>
                <div className="px-6 mt-4 mb-6">
                    <form className="flex flex-row flex-wrap items-center">
                        <div className="relative flex w-full flex-wrap items-stretch">
                            <span className="z-10 h-full leading-snug font-normal absolute text-center text-white absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
                                <i className="fas fa-search"></i>
                            </span>
                            <Tooltip title="Search Record" arrow>
                                <input
                                    type="text"
                                    placeholder="Search by Project Title"
                                    className="border-0 px-3 py-3 placeholder-blueGray-400 text-white relative bg-blueGray-700 rounded text-sm shadow outline-none focus:outline-none focus:ring w-full pl-10 pr-10"
                                    value={searchTerm}
                                    onChange={(e) => {
                                        setSearchTerm(e.target.value);
                                        setCurrentPage(1);
                                    }} />
                            </Tooltip>
                            {searchTerm && (
                                <button
                                    type="button"
                                    onClick={() => setSearchTerm('')}
                                    className="absolute right-0 top-0 bottom-0 flex items-center justify-center w-10 text-white hover:text-blueGray-300 focus:outline-none">
                                    <i className="fas fa-times"></i>
                                </button>
                            )}
                        </div>
                    </form>
                </div>

                {loading ? (
                    <div className="flex justify-center items-center h-64">
                        <PropagateLoader color="#141c52" size={18} />
                    </div>
                ) :
                    (
                        <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-blueGray-700">
                            <div className="block w-full overflow-x-auto">
                                <table className="items-center w-full bg-transparent border-collapse">
                                    <thead>
                                        <tr>
                                            <th className="px-6 min-w-[200px] border border-solid py-3 text-sm font-bold text-left bg-blueGray-700 text-white border-blueGray-600">
                                                Sr.No
                                            </th>
                                            <th className="px-6 min-w-[200px] border border-solid py-3 text-sm font-bold text-left bg-blueGray-700 text-white border-blueGray-600"
                                                onClick={() => handleSort('studentsName')}>
                                                Name{sortColumn === 'studentsName' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
                                            </th>
                                            <th className="px-6 min-w-[200px] border border-solid py-3 text-sm font-bold text-left bg-blueGray-700 text-white border-blueGray-600"
                                                onClick={() => handleSort('facility')}>
                                                Facility {sortColumn === 'facility' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
                                            </th>
                                            <th className="px-6 min-w-[200px] border border-solid py-3 text-sm font-bold text-left bg-blueGray-700 text-white border-blueGray-600"
                                                onClick={() => handleSort('phone')}>
                                                Phone {sortColumn === 'phone' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
                                            </th>
                                            <th className="px-6 min-w-[200px] border border-solid py-3 text-sm font-bold text-left bg-blueGray-700 text-white border-blueGray-600"
                                                onClick={() => handleSort('purpose')}>
                                                Purpose {sortColumn === 'purpose' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
                                            </th>
                                            
                                            <th className="px-6 min-w-[200px] border border-solid py-3 text-sm font-bold text-left bg-blueGray-700 text-white border-blueGray-600"
                                                onClick={() => handleSort('status')} >
                                                Status {sortColumn === 'status' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
                                            </th>
                                            <th className="px-6 min-w-[200px] border border-solid py-3 text-sm font-bold text-left bg-blueGray-700 text-white border-blueGray-600"
                                                onClick={() => handleSort('start_date_time')}>
                                                Start Date & Time {sortColumn === 'start_date_time' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
                                            </th>
                                            <th className="px-6 min-w-[200px] border border-solid py-3 text-sm font-bold text-left bg-blueGray-700 text-white border-blueGray-600"
                                                onClick={() => handleSort('end_date_time')} >
                                                End Date & Time  {sortColumn === 'end_date_time' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
                                            </th>
                                            {/* <th className="px-6 min-w-[200px] border border-solid py-3 text-sm font-bold text-left bg-blueGray-700 text-white border-blueGray-600"
                                                onClick={() => handleSort('description')}>
                                                Description{sortColumn === 'description' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
                                            </th> */}
                                            <th className="px-6 min-w-[200px] border border-solid py-3 text-sm font-bold text-left bg-blueGray-700 text-white border-blueGray-600">
                                                Action
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentItems.length ? currentItems.map((item, index) => (
                                            <tr key={item.facility_registration_id}>
                                                <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left border-blueGray-700">
                                                    <span className="font-bold text-white">{(currentPage - 1) * itemsPerPage + index + 1}</span>
                                                </td>
                                                 <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left border-blueGray-700">
                                                    <span className="font-bold text-white capitalize">{item.studentsName}</span>
                                                </td>
                                                <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left border-blueGray-700">
                                                    <span className="font-bold text-white">{item.facility}</span>
                                                </td>
                                                <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left border-blueGray-700">
                                                    <span className="font-bold text-white">{item.phone}</span>
                                                </td>
                                                <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left border-blueGray-700">
                                                    <span className="font-bold text-white">{item.purpose}</span>
                                                </td>
                                                <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 border-blueGray-700">
                                                    <span className="font-bold text-white">
                                                        {item.status }
                                                    </span>
                                                </td>
                                                <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 border-blueGray-700">
                                                    <span className="font-bold text-white">{new Date(item.start_date_time).toLocaleString()}</span>
                                                </td>
                                                <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 border-blueGray-700">
                                                    <span className="font-bold text-white">{new Date(item.end_date_time).toLocaleString()}</span>
                                                </td>
                                                {/* <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left">
                                                    <span className="ml-0 font-bold text-blueGray-600">{item?.description?.length > 30 ? item?.description.substring(0, 30) + '...' : item.description}</span>
                                                </td> */}
                                                <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-center flex gap-4">
                                                    <Tooltip title="Edit" arrow>
                                                        <motion.button
                                                            whileHover={{ scale: 1.2, color: "#2563EB" }}
                                                            whileTap={{ scale: 0.9 }}
                                                            type="button"
                                                            onClick={() => navigate(`/admin/editFacilityReservation`,{ state: { type:"edit",id: item.facility_registration_id,  fid:item.facility_id } })}
                                                            className="text-blue-500 hover:text-blue-700 focus:outline-none">
                                                            <FontAwesomeIcon icon={faPenToSquare} className="text-xl" />
                                                        </motion.button>
                                                    </Tooltip>
                                                    <Tooltip title="Delete" arrow>
                                                        <motion.button
                                                            whileHover={{ scale: 1.2, color: "#DC2626" }}
                                                            whileTap={{ scale: 0.9 }}
                                                            type="button"
                                                            onClick={() => handleDelete(item.facility_registration_id)}
                                                            className="text-blue-500 hover:text-red-700 focus:outline-none mx-4">
                                                            <FontAwesomeIcon icon={faTrash} className="text-xl" />
                                                        </motion.button>
                                                    </Tooltip>
                                                    <Tooltip title="View" arrow>
                                                        <motion.button
                                                            whileHover={{ scale: 1.2, color: "#FACC15" }}
                                                            whileTap={{ scale: 0.9 }}
                                                            type="button"
                                                            onClick={() => navigate(`/admin/viewFacilityReservation`,{ state: { type:"view",id: item.facility_registration_id,fid:item.facility_id } })}
                                                            className="text-blue-500 focus:outline-none mx-3 hover:text-yellow-500">
                                                            <FontAwesomeIcon icon={faEye} className="text-xl" />
                                                        </motion.button>
                                                    </Tooltip>
                                                    <Tooltip title="Scan Qr" arrow>
                                                        <motion.button
                                                            whileHover={{ scale: 1.2, color: "#22C55E" }}
                                                            whileTap={{ scale: 0.9 }}
                                                            type="button"
                                                            onClick={() => handleShowQR(item.facility_registration_id, item)}
                                                            className="text-blue-500 focus:outline-none mx-4 hover:text-green-500">
                                                            <FontAwesomeIcon icon={faQrcode} className="text-xl" />
                                                        </motion.button>
                                                    </Tooltip>
                                                </td>
                                            </tr>
                                        )) : <tr>
                                            <td colSpan={8} className="text-1xl text-center align-middle bg-blueGray-700 text-white font-semibold p-4">
                                                No Data Found
                                            </td>
                                        </tr>}
                                    </tbody>
                                </table>
                                {/* {currentItems.length ? (
                                    <div className="flex justify-center mt-4 space-x-2 bg-gray-100 p-2 rounded-lg">
                                        <button
                                            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                                            disabled={currentPage === 1}
                                            className={`py-2 px-4 mx-1 rounded-lg border ${currentPage === 1
                                                ? 'bg-gray-300 text-black-900 cursor-not-allowed'
                                                : 'bg-gray-300 text-black-900 border-gray-400 hover:bg-gray-400'
                                                }`}>
                                            <span>
                                                <svg
                                                    width="20"
                                                    height="21"
                                                    viewBox="0 0 20 21"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M17.5 9.8125H4.15625L9.46875 4.40625C9.75 4.125 9.75 3.6875 9.46875 3.40625C9.1875 3.125 8.75 3.125 8.46875 3.40625L2 9.96875C1.71875 10.25 1.71875 10.6875 2 10.9688L8.46875 17.5312C8.59375 17.6562 8.78125 17.75 8.96875 17.75C9.15625 17.75 9.3125 17.6875 9.46875 17.5625C9.75 17.2812 9.75 16.8438 9.46875 16.5625L4.1875 11.2188H17.5C17.875 11.2188 18.1875 10.9062 18.1875 10.5312C18.1875 10.125 17.875 9.8125 17.5 9.8125Z"
                                                        fill="currentColor"
                                                    />
                                                </svg>
                                            </span>
                                        </button>
                                        {(() => {
                                            const pagesToShow = 3;
                                            let startPage = Math.max(currentPage - 1, 1);
                                            let endPage = Math.min(startPage + pagesToShow - 1, totalPages);

                                            if (endPage - startPage + 1 < pagesToShow) {
                                                startPage = Math.max(endPage - pagesToShow + 1, 1);
                                            }
                                            const pages = [];
                                            for (let i = startPage; i <= endPage; i++) {
                                                pages.push(
                                                    <button
                                                        key={i}
                                                        className={`py-2 px-4 mx-1 rounded-lg border ${currentPage === i
                                                            ? 'bg-blue-500 text-black'
                                                            : 'bg-gray-300 text-gray-700 border-gray-400 hover:bg-gray-400'
                                                            }`}
                                                        onClick={() => setCurrentPage(i)}
                                                    >
                                                        {i}
                                                    </button>
                                                );
                                            }
                                            return pages;
                                        })()}

                                        <button
                                            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                                            disabled={currentPage === totalPages}
                                            className={`py-2 px-4 mx-1 rounded-lg border ${currentPage === totalPages
                                                ? 'bg-gray-300 text-black-900 cursor-not-allowed'
                                                : 'bg-gray-300 text-black-900 border-gray-400 hover:bg-gray-400'
                                                }`}
                                        >
                                            <span>
                                                <svg
                                                    width="20"
                                                    height="21"
                                                    viewBox="0 0 20 21"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M18 10L11.5312 3.4375C11.25 3.15625 10.8125 3.15625 10.5312 3.4375C10.25 3.71875 10.25 4.15625 10.5312 4.4375L15.7812 9.78125H2.5C2.125 9.78125 1.8125 10.0937 1.8125 10.4688C1.8125 10.8438 2.125 11.1875 2.5 11.1875H15.8437L10.5312 16.5938C10.25 16.875 10.25 17.3125 10.5312 17.5938C10.6562 17.7188 10.8437 17.7812 11.0312 17.7812C11.2187 17.7812 11.4062 17.7188 11.5312 17.5625L18 11C18.2812 10.7187 18.2812 10.2812 18 10Z"
                                                        fill="currentColor"
                                                    />
                                                </svg>
                                            </span>
                                        </button>
                                    </div>
                                ) : ''} */}
                                {currentItems.length > 0 && (
                                  <div 
                                  className="flex justify-center mt-4 bg-blueGray-700 p-4 rounded-lg"
                                  >
                                    <TablePagination
                                      component="p"
                                      count={totalItems}              // total number of items, not pages
                                      page={currentPage - 1}          // MUI pages are 0-indexed
                                      onPageChange={(event, newPage) => setCurrentPage(newPage + 1)}
                                      rowsPerPage={itemsPerPage}     
                                      onRowsPerPageChange={(event) => {
                                        setItemsPerPage(parseInt(event.target.value, 10));
                                        setCurrentPage(1);          
                                      }}
                                      rowsPerPageOptions={[1,5, 10, 25, 50]} 
                                      labelRowsPerPage="Items per page"
                                      sx={{
                                        '& .MuiTablePagination-toolbar': {
                                          fontWeight: 500,         
                                          fontSize: '0.75rem',
                                          color: 'white',
                                        },
                                        '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                                          fontWeight: 500,
                                           fontSize: '0.75rem',
                                           color: 'white',
                                        },
                                        '& .MuiTablePagination-select': {
                                          fontWeight: 500,
                                           fontSize: '0.75rem',
                                           color: 'white',
                                        },
                                        '& .MuiTablePagination-selectIcon': {
                                          color: 'white',
                                        },
                                        '& .MuiIconButton-root': {
                                          color: 'white',
                                        },
                                      }}
                                    />
                                  </div>
                                )}
                            </div>
                        </div>
                    )}
            </div>
        </>
    )
}